const toCsvSafe = (value) => {
  const raw = value === null || value === undefined ? '' : String(value)
  const escaped = raw.replace(/"/g, '""')
  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped
}

const formatBookmarkDate = (dateInput) => {
  if (!dateInput) return 'N/A'

  let date = null
  if (Array.isArray(dateInput)) {
    const [year, month, day, hour = 0, minute = 0, second = 0, nanosecond = 0] =
      dateInput
    date = new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        hour,
        minute,
        second,
        Math.floor(nanosecond / 1000000)
      )
    )
  } else if (typeof dateInput === 'string') {
    date = new Date(dateInput)
  }

  if (!date || Number.isNaN(date.getTime())) {
    return 'N/A'
  }

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

const normalizeBookmarkUrl = (url) => {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/')) return `${window.location.origin}${url}`
  return `${window.location.origin}/${url}`
}

export const exportBookmarksToCSV = (
  bookmarks,
  filename = 'user_bookmarks'
) => {
  if (!Array.isArray(bookmarks) || bookmarks.length === 0) {
    throw new Error('No bookmarks to export')
  }

  const headers = [
    'Title',
    'Link',
    'Article Slug',
    'Category',
    'Starred',
    'Description',
    'Created Date',
  ]

  const rows = bookmarks.map((bookmark) => [
    bookmark?.title || '',
    normalizeBookmarkUrl(bookmark?.url),
    bookmark?.articleSlug || '',
    bookmark?.category || '',
    bookmark?.isStarred ? 'Yes' : 'No',
    bookmark?.description || '',
    formatBookmarkDate(bookmark?.createdAt),
  ])

  const csvLines = [
    headers.map(toCsvSafe).join(','),
    ...rows.map((row) => row.map(toCsvSafe).join(',')),
  ]

  const blob = new Blob([csvLines.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute(
    'download',
    `${filename}_${new Date().toISOString().slice(0, 10)}.csv`
  )
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
